import {htmlToPortableText} from '@portabletext/html'
import {toHTML} from '@portabletext/to-html'
import {getFragment} from '../selectors/selector.get-fragment'
import {parseBlock} from '../utils/parse-blocks'
import {defineConverter} from './converter.types'

export const converterTextHtml = defineConverter({
  mimeType: 'text/html',
  serialize: ({snapshot, event}) => {
    const selection = snapshot.context.selection

    if (!selection) {
      return {
        type: 'serialization.failure',
        mimeType: 'text/html',
        originEvent: event.originEvent,
        reason: 'No selection',
      }
    }

    const blocks = getFragment(snapshot).map((entry) => entry.node)

    const html = toHTML(blocks, {
      onMissingComponent: false,
      components: {
        unknownType: ({children}) =>
          children !== undefined ? `${children}` : '',
      },
    })

    if (html === '') {
      return {
        type: 'serialization.failure',
        mimeType: 'text/html',
        originEvent: event.originEvent,
        reason: 'Serialized HTML is empty',
      }
    }

    return {
      type: 'serialization.success',
      data: html,
      mimeType: 'text/html',
      originEvent: event.originEvent,
    }
  },
  deserialize: ({snapshot, event}) => {
    const blocks = htmlToPortableText(event.data, {
      schema: snapshot.context.schema,
      keyGenerator: snapshot.context.keyGenerator,
    })

    const parsedBlocks = blocks.flatMap((block) => {
      const parsedBlock = parseBlock({
        keyGenerator: snapshot.context.keyGenerator,
        block,
        options: {
          normalize: false,
          removeUnusedMarkDefs: true,
          validateFields: false,
        },
        schema: snapshot.context.schema,
      })
      return parsedBlock ? [parsedBlock] : []
    })

    if (parsedBlocks.length === 0) {
      return {
        type: 'deserialization.failure',
        mimeType: 'text/html',
        reason: 'No blocks deserialized',
      }
    }

    return {
      type: 'deserialization.success',
      data: parsedBlocks,
      mimeType: 'text/html',
    }
  },
})
